import { Component, OnInit } from '@angular/core';

import { AuthService } from '@core/providers';
import { companyName, logo } from '@env/environment';
import { RouteInfo } from './models/router-info.model';

@Component({
  selector: 'app-sidebar',
  templateUrl: `./sidebar.component.html`,
})
export class SidebarComponent implements OnInit {
  menuItems: RouteInfo[];
  logo = logo;
  company = companyName;

  constructor(public auth: AuthService) {}

  ngOnInit() {
    this.createMenu();
  }

  authRole(role: string[]): boolean {
    return role.includes(this.auth.getToken().user?.role);
  }

  createMenu() {
    this.menuItems = [
      {
        path: '/dashboard',
        title: 'Dashboard',
        type: 'link',
        iconType: 'tim-icons icon-chart-pie-36',
        permission: ['SUPER_ADMIN', 'ADMIN', 'USER'],
      },
      {
        path: '/deals',
        title: 'Deals',
        type: 'link',
        iconType: 'tim-icons icon-paper',
        permission: ['SUPER_ADMIN', 'ADMIN', 'USER'],
      },
      {
        path: '/reports',
        title: 'Reports',
        type: 'link',
        iconType: 'tim-icons icon-chart-bar-32',
        permission: ['SUPER_ADMIN'],
      },
      {
        path: '/services',
        title: 'Services',
        type: 'sub',
        iconType: 'tim-icons icon-settings',
        isCollapsed: true,
        children: [
          {
            path: 'commercial',
            title: 'Commercial Credit',
            smallTitle: 'CC',
            type: 'link',
            permission: ['SUPER_ADMIN', 'ADMIN', 'USER'],
          },
          {
            path: 'company',
            title: 'Company register',
            smallTitle: 'CR',
            type: 'link',
            permission: ['SUPER_ADMIN', 'ADMIN', 'USER'],
          },
          {
            path: 'personal',
            title: 'Personal Credit',
            smallTitle: 'PC',
            type: 'link',
            permission: ['SUPER_ADMIN', 'ADMIN', 'USER'],
          },
          {
            path: 'taxes',
            title: 'Personal Taxes',
            smallTitle: 'PT',
            type: 'link',
            permission: ['SUPER_ADMIN', 'ADMIN', 'USER'],
          },
          {
            path: 'small',
            title: 'Small Business',
            smallTitle: 'SB',
            type: 'link',
            permission: ['SUPER_ADMIN', 'ADMIN', 'USER'],
          },
        ],
      },
      {
        path: '/companies',
        title: 'Companies',
        type: 'sub',
        iconType: 'tim-icons icon-badge',
        collapse: 'companies',
        isCollapsed: true,
        children: [
          {
            path: 'all',
            title: 'List',
            type: 'link',
            smallTitle: 'CL',
            permission: ['SUPER_ADMIN', 'ADMIN', 'USER'],
          },
          {
            path: 'blacklist',
            title: 'Blacklist',
            type: 'link',
            smallTitle: 'CB',
            permission: ['SUPER_ADMIN', 'ADMIN', 'USER'],
          },
        ],
      },
      {
        path: '/lenders',
        title: 'lenders',
        type: 'link',
        iconType: 'tim-icons icon-bank',
        permission: ['SUPER_ADMIN', 'ADMIN'],
      },
      {
        path: '/lenderslists',
        title: 'Lenders Lists',
        type: 'link',
        iconType: 'tim-icons icon-notes',
        permission: ['SUPER_ADMIN', 'ADMIN'],
      },
      {
        path: '/users',
        title: 'Users',
        type: 'link',
        iconType: 'tim-icons icon-single-02',
        permission: ['SUPER_ADMIN'],
      },
    ];
  }
}
